/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class PushApi {
    constructor(api) {
        this.api = api;
    }

    /**
     *
     * @param conventionId
     */
    async getAllByConventionId(conventionId) {
        const result = await this.api.get(`/pushes/findByCC/${conventionId}`, {
            size: 5,
            sort: "sentAt,desc",
        });
        return result._embedded ? result._embedded.pushes : [];
    }

    /**
     *
     * @param pushId
     */
    async getById(pushId) {
        const push = await this.api.get(`/pushes/${pushId}`);
        return push;
    }
}
